import { ValidLocale } from '@localisation'
import { updateCurrentUser } from '@query'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useMutation } from '@tanstack/react-query'
import styled from 'styled-components'
import { SUPPORTED_LANGUAGES } from '@constants'
import { Select } from '@components'
import { isWindows } from 'react-device-detect'

export const LanguagePicker: React.FC = () => {
  const {
    t,
    i18n: { language: currentLanguage }
  } = useTranslation()

  const languageMutation = useMutation<unknown, unknown, ValidLocale>({
    mutationFn: language => updateCurrentUser(undefined, { language: language }),
    ...{
      onSuccess: async () => window.location.reload()
    }
  })

  return (
    <StyledLanguagePicker>
      <Select
        label={t('components.languagePicker.language')}
        value={currentLanguage}
        onChange={e => languageMutation.mutate(e.target.value)}
      >
        {SUPPORTED_LANGUAGES.map(({ value, labelKey }) => (
          <option key={value} value={value}>
            {isWindows ? '' : t(`flags.${value}`)} {t(labelKey, { lng: value })}
          </option>
        ))}
      </Select>
    </StyledLanguagePicker>
  )
}

const StyledLanguagePicker = styled.div`
  padding: ${({ theme }) => theme.spacing.sm}rem ${({ theme }) => theme.spacing.sm}rem;

  & > * {
    margin: 0;
  }
`
